import "../stakeholderlayout.css";

export default function Corporate() {
  return (
    <section className="page-wrapper">
      <div className="container">

        {/* Hero Section */}
        <h2 className="hero-title">
          Systems & Strategy Support for Corporates & Organizations
        </h2>

        <h3 className="hero-subtitle">
          Enterprise strategy, governance design, operating models, capability systems,
          and communication integrity.
        </h3>

        <p className="hero-text">
          Organizations do not fail only due to lack of talent or resources. They fail
          when strategies, structures, incentives, processes, and communication systems
          are misaligned. We support organizations in building coherent systems that
          execute with clarity and accountability.
        </p>

        <div className="button-group">
          <button className="primary-btn">
            Describe Your Organizational Challenge
          </button>
          <button className="secondary-btn">
            Request a Structured Diagnosis
          </button>
        </div>

        <p className="form-note">
          We treat organizational enquiries with confidentiality and seriousness.
          Submission does not create a binding engagement.
        </p>

        {/* Organizational Reality */}
        <h2 className="section-title">The Organizational Reality</h2>

        <p className="section-intro">
          Organizations often operate under:
        </p>

        <ul className="problem-list">
          <li>Cross-functional complexity and siloed execution</li>
          <li>Multiple stakeholders across governance levels</li>
          <li>Rapid technology and market change</li>
          <li>Incentive conflicts between functions and time horizons</li>
          <li>Documentation gaps and weak institutional memory</li>
          <li>Reputation risk and communication noise</li>
        </ul>

        <p className="insight-text">
          Many corporate problems are not technical failures. They are system design failures.
        </p>

        {/* Breakdown Map */}
        <h2 className="section-title">Where Organizations Typically Break Down</h2>

        <ol className="challenges-list">
          <li>
            <strong>Strategy–Execution Gap</strong><br />
            Strategy exists on paper, but ownership and feedback loops are unclear.
          </li>
          <li>
            <strong>Governance & Accountability Confusion</strong><br />
            Delayed decisions, diffused accountability, symbolic committees.
          </li>
          <li>
            <strong>Operating Model Misalignment</strong><br />
            Structure does not match strategic intent.
          </li>
          <li>
            <strong>Incentive & Culture Drift</strong><br />
            KPIs drive unintended behaviour and weaken trust.
          </li>
          <li>
            <strong>Communication Integrity Risk</strong><br />
            External narratives diverge from internal reality.
          </li>
        </ol>

        {/* Structured Solution Architecture */}
        <h2 className="section-title">Structured Solution Architecture</h2>

        <p className="note-text">
          Only the most relevant solution pathways are activated.
        </p>

        {/* Section A */}
        <h3 className="subsection-title">
          SECTION A: Enterprise Strategy & Institutional Design
        </h3>

        <p className="provider">
          Delivered through: Vasudheva Strategic Innovations Pvt. Ltd.
        </p>

        <ul className="focus-list">
          <li>Strategic coherence and positioning</li>
          <li>Multi-year roadmap architecture</li>
          <li>Institutional design and decision systems</li>
          <li>Competitive and market intelligence</li>
        </ul>

        <button className="btn explore">
          Explore Enterprise Strategy Solutions
        </button>

        {/* Section B */}
        <h3 className="subsection-title">
          SECTION B: Governance, Risk & Decision Systems
        </h3>

        <ul className="focus-list">
          <li>Board and leadership decision protocols</li>
          <li>Accountability chains and escalation paths</li>
          <li>Risk governance and control frameworks</li>
          <li>Policy architecture (ethics, COI, data governance)</li>
        </ul>

        <button className="btn explore">
          Explore Governance & Risk Systems
        </button>

        {/* Section C */}
        <h3 className="subsection-title">
          SECTION C: Operating Model & Process Architecture
        </h3>

        <ul className="focus-list">
          <li>Org design and workflow mapping</li>
          <li>SOP systems and documentation</li>
          <li>KPI/OKR architecture aligned to strategy</li>
          <li>Coordination and efficiency redesign</li>
        </ul>

        <button className="btn explore">
          Explore Operating Model & Process Design
        </button>

        {/* Section D */}
        <h3 className="subsection-title">
          SECTION D: Leadership & Capability Systems
        </h3>

        <ul className="focus-list">
          <li>Leadership development aligned to institutional needs</li>
          <li>Role-based capability gap diagnosis</li>
          <li>Continuous learning systems</li>
          <li>Internal knowledge architecture</li>
        </ul>

        <button className="btn explore">
          Explore Capability & Leadership Systems
        </button>

        {/* Section E */}
        <h3 className="subsection-title">
          SECTION E: Communication Integrity & Stakeholder Trust
        </h3>

        <ul className="focus-list">
          <li>Communication governance frameworks</li>
          <li>Reputation risk mapping</li>
          <li>Crisis readiness protocols</li>
          <li>Stakeholder narrative alignment</li>
        </ul>

        <button className="btn explore">
          Explore Communication & Trust Systems
        </button>

        {/* Engagement Modes */}
        <h2 className="section-title">
          How Organizational Engagements Typically Begin
        </h2>

        <ol className="process-list">
          <li>Diagnostic & Clarity Phase</li>
          <li>Architecture & Design Phase</li>
          <li>Implementation Support</li>
          <li>Evaluation & Learning Review</li>
        </ol>

        <p className="principle-text">
          We begin with structure and evidence — not generic consulting decks.
        </p>

        {/* Action Zone */}
        <h2 className="section-title">Start a Structured Conversation</h2>

        <div className="button-group">
          <button className="primary-btn">
            Describe Your Organizational Challenge
          </button>
          <button className="secondary-btn">
            Request a Structured Diagnosis
          </button>
        </div>

        <p className="form-note">
          Please share only what you are authorised to disclose.
          Confidentiality arrangements can be initiated prior to deeper exchange.
        </p>

        {/* Footer */}
        <p className="footer-note">
          Vasudheva Holdings Pvt. Ltd. provides governance and integration across the Group.
          Formal engagements are executed by the relevant subsidiary entity under written agreement.
        </p>

      </div>
    </section>
  );
}
